import React from 'react';
import '../style.css';
import { TextIcon } from '../TextIcon';

export type MachineCardItemProps = {
    className: string;
    title: string;
    borderColor: string;
    description: string;
    imageSrc: string;
    icon: any;
    iconText: string;
}
export const MachineCardItem = ({ title, description, className, imageSrc, icon, iconText, borderColor }: MachineCardItemProps) => {
    const handleClick = () => {
        // alert(new Date().toLocaleDateString())
    }
    return (
        <div className={`_247FactoryNet-machineCardItem ${className}`} onClick={handleClick}>
            <div className='imageWrapper'>
                {
                    typeof imageSrc === 'string' ?  <div className='image' style={{ backgroundImage: `url(${imageSrc})` }}></div> : <div className='imgFile'><img src={imageSrc}/></div>
                }
                
            </div>
            <div className='contentWrapper'>
                <div className='borderTop' style={{ borderTopColor: borderColor }}></div>
                <div className="content">
                    <div className="title">{title}</div>
                    <div className="description">{description} <br />
                        <TextIcon icon={icon} iconText={iconText} className='' />
                    </div>
                </div>
            </div>
        </div>
    )
}